<template>
  <modal :show="show" id="log-edit" @close="close()">
    <div class="modal-head">
      <h2>Edit Log</h2>
    </div>
    <div class="modal-content">
      <form @submit.prevent="update()">
        <div class="form-control">
          <label for="type">Type</label>
          <select v-model="input.type" name="type" id="type">
            <option value disabled selected>--</option>
            <option>Notes</option>
            <option>Followup</option>
            <option>Billing Hold</option>
            <option>Cancellation</option>
          </select>
        </div>

        <div class="form-control">
          <label for="description">Description</label>
          <textarea v-model="input.description"></textarea>
        </div>

        <button class="button button-green">Save Log</button>
        <button @click.prevent="close()" class="button button-gray">Cancel</button>
      </form>
    </div>
  </modal>
</template>


<script>
import Modal from "@/components/ui/Modal";

export default {
  name: "LogEdit",
  props: ["show", "log"],
  components: {
    Modal
  },
  data() {
    return {
      input: {
        type: null,
        description: null
      }
    };
  },
  watch: {
    log(value) {
      this.input = value;
    }
  },
  methods: {
    async update() {
      let response = await this.$http.put(
        "/paid-media-budgets/" +
          this.input.client_id +
          "/logs/" +
          this.input.id,
        this.input
      );
      this.$emit("update");
      this.$emit("close");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
#log-edit {
}
</style>
